import React, {Component} from 'react';
import '../../../../styles/Home.css'
import '../../../../styles/Miesieczne.css'
import Select from 'react-select'
import {Button} from "react-bootstrap";
import BiletyMiesieczneService from "./BiletyMiesieczneService";
import BiletyMiesiecznePokaz from "./BiletyMiesiecznePokaz";
import * as acc from "accounting";
import {Link} from "react-router-dom";
import PokazSzczegolyKarty from "./PokazSzczegolyKarty";
import ZnizkaUstawowa from "../daneComponents/ZnizkaUstawowa";
import moment from "moment";
import Panel from "../../Panel";
import {NotificationManager} from "react-notifications";
import LoginService from "../../../../admin/loginComponents/LoginService";

const miesiace = [
    {value: 1, label: 'styczeń'},
    {value: 2, label: 'luty'},
    {value: 3, label: 'marzec'},
    {value: 4, label: 'kwiecień'},
    {value: 5, label: 'maj'},
    {value: 6, label: 'czerwiec'},
    {value: 7, label: 'lipiec'},
    {value: 8, label: 'sierpień'},
    {value: 9, label: 'wrzesień'},
    {value: 10, label: 'październik'},
    {value: 11, label: 'listopad'},
    {value: 12, label: 'grudzień'}
];

export default class BiletyMiesieczne extends Component {

    constructor(props) {
        super(props);


        this.state = {
            kierunek: {value: 2, label: 'W obie strony'},
            lata: [
                {value: new Date().getFullYear(), label: new Date().getFullYear()},
                {value: new Date().getFullYear() + 1, label: new Date().getFullYear() + 1}
            ],
            rok: {value: new Date().getFullYear(), label: new Date().getFullYear()},
            miesiace: miesiace,
            miesiaceList: miesiace,
            miesiac: miesiace[new Date().getMonth() + 1],
            okresy: [
                {value: 'M1', label: 'na cały miesiąc'},
                {value: 'P1', label: 'pierwsza połowa miesiąca'},
                {value: 'P2', label: 'druga połowa miesiąca'}
            ],
            okres: {value: 'M1', label: 'na cały miesiąc'},
            miejscowosci: [],
            miejscowosciDo: [],
            miejscowoscOd: '',
            miejscowoscDo: '',
            typy: [],
            typ: '',
            statusy: [],
            status: '',
            uwagi: '',
            trasy: [],
            trasa: '',
            disabled: true,
            data: [],
            loading: true,
            showComponent: '',
            pokazSzczegolyKarty: false,
            znizkaUstawowa: false,
            idKa: '',
            tylkoEkarta: false,
        };

        this.onChangeTrasa = this.onChangeTrasa.bind(this);
        this.onChangeMiejscowoscOd = this.onChangeMiejscowoscOd.bind(this);
        this.onChangeMiejscowoscDo = this.onChangeMiejscowoscDo.bind(this);
        this.onChangeKierunek = this.onChangeKierunek.bind(this);
        this.onChangeRok = this.onChangeRok.bind(this);
        this.onChangeMiesiac = this.onChangeMiesiac.bind(this);
        this.onChangeOkres = this.onChangeOkres.bind(this);
        this.onChangeTyp = this.onChangeTyp.bind(this);
        this.onChangeUwagi = this.onChangeUwagi.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        this.setState({pokazSzczegolyKarty: nextProps.pokazSzczegoly})
    }

    getMiesiace() {
        let miesiace = [];
        let lata = [];
        if (new Date().getDate() <= 25) {
            if (new Date().getMonth() + 1 === 12) {
                lata = [{
                    value: new Date().getFullYear() + 1,
                    label: new Date().getFullYear() + 1
                }, {value: new Date().getFullYear() + 2, label: new Date().getFullYear() + 2}];
                miesiace = this.state.miesiaceList;
            } else {
                lata = [{
                    value: new Date().getFullYear(),
                    label: new Date().getFullYear()
                }, {value: new Date().getFullYear() + 1, label: new Date().getFullYear() + 1}];
                for (let i = new Date().getMonth() + 1; i < this.state.miesiaceList.length; i++) {
                    miesiace.push(this.state.miesiaceList[i])
                }
            }
        } else {
            if (new Date().getMonth() + 2 === 12) {
                lata = [{
                    value: new Date().getFullYear() + 1,
                    label: new Date().getFullYear() + 1
                }, {value: new Date().getFullYear() + 2, label: new Date().getFullYear() + 2}];
                miesiace = this.state.miesiaceList;
            } else {
                if (new Date().getMonth() + 1 === 12) {
                    lata = [{
                        value: new Date().getFullYear() + 1,
                        label: new Date().getFullYear() + 1
                    }, {value: new Date().getFullYear() + 2, label: new Date().getFullYear() + 2}];
                    for (let i = 1; i < this.state.miesiaceList.length; i++) {
                        miesiace.push(this.state.miesiaceList[i])
                    }
                } else {
                    lata = [{
                        value: new Date().getFullYear(),
                        label: new Date().getFullYear()
                    }, {value: new Date().getFullYear() + 1, label: new Date().getFullYear() + 1}];
                    for (let i = new Date().getMonth() + 2; i < this.state.miesiaceList.length; i++) {
                        miesiace.push(this.state.miesiaceList[i])
                    }
                }
            }
        }

        console.log(miesiace)
        console.log(lata)

        this.setState({miesiace: miesiace, lata: lata, miesiac: miesiace[0], rok: lata[0]})
    }

    onChangeTrasa(e) {
        this.setState({trasa: e, disabled: false, typ: '', znizkaUstawowa: false});
        this.getMiejscowosci(e.value)
    }

    onChangeMiejscowoscOd(e) {
        this.setState({
            miejscowoscOd: e,
            typ: '', znizkaUstawowa: false,
            miejscowosciDo: this.state.miejscowosci.slice(this.state.miejscowosci.indexOf(e)),
            miejscowoscDo: this.state.miejscowosci[this.state.miejscowosci.length - 1]
        });
        this.getZnizki(this.state.rok.value, this.state.miesiac.value, e.value, this.state.miejscowoscDo.value,
            this.state.trasa.value, this.state.kierunek.value, this.state.okres.value)
    }

    onChangeMiejscowoscDo(e) {
        this.setState({miejscowoscDo: e, typ: '', znizkaUstawowa: false});
        this.getZnizki(this.state.rok.value, this.state.miesiac.value, this.state.miejscowoscOd.value,
            e.value, this.state.trasa.value, this.state.kierunek.value, this.state.okres.value)
    }

    onChangeKierunek(e) {
        this.setState({kierunek: e, typ: '', znizkaUstawowa: false});
        this.getZnizki(this.state.rok.value, this.state.miesiac.value, this.state.miejscowoscOd.value,
            this.state.miejscowoscDo.value, this.state.trasa.value, e.value, this.state.okres.value)
    }

    onChangeRok(e) {
        if (e.value > moment().format('YYYY')){
            this.setState({miesiace: miesiace, miesiac: miesiace[0]})
        } else {
            this.getMiesiace()
        }
        this.setState({rok: e, typ: '', znizkaUstawowa: false});
        this.getZnizki(e.value, this.state.miesiac.value, this.state.miejscowoscOd.value,
            this.state.miejscowoscDo.value, this.state.trasa.value, this.state.kierunek.value, this.state.okres.value)
    }

    onChangeMiesiac(e) {
        this.setState({miesiac: e, typ: '', znizkaUstawowa: false});
        this.getZnizki(this.state.rok.value, e.value, this.state.miejscowoscOd.value,
            this.state.miejscowoscDo.value, this.state.trasa.value, this.state.kierunek.value, this.state.okres.value)
    }

    onChangeOkres(e) {
        this.setState({okres: e, typ: '', znizkaUstawowa: false});
        this.getZnizki(this.state.rok.value, this.state.miesiac.value, this.state.miejscowoscOd.value,
            this.state.miejscowoscDo.value, this.state.trasa.value, this.state.kierunek.value, e.value)
    }

    onChangeTyp(e) {
        if (e.ulga === true) {
            this.setState({znizkaUstawowa: true, typ: e})
        } else {
            this.setState({znizkaUstawowa: false, typ: e})
        }
    }

    onChangeUwagi(e) {
        this.setState({uwagi: e.target.value})
    }

    peselCheck(pesel) {
        if (Boolean(pesel)) {
            if (pesel.length === 11) {
                let nowyear = new Date().toJSON().substr(0, 4);
                let nowmonth = new Date().toJSON().substr(5, 2);
                let nowday = new Date().toJSON().substr(8, 2);
                let wiek = 0;
                if (pesel[2] === '2' || pesel[2] === '3') {  // roczniki 2000
                    wiek = parseInt(nowyear) - parseInt('20' + pesel.substr(0, 2));

                    let peselmonth = pesel.substr(2, 2);
                    if (peselmonth[0] == '2') { // sty - wrze
                        if (parseInt('0' + peselmonth[1]) == parseInt(nowmonth)) {
                            if (parseInt(pesel.substr(4, 2)) > parseInt(nowday)) {
                                wiek = wiek - 1;
                            }
                        } else if (parseInt('0' + peselmonth[1]) > parseInt(nowmonth)) {
                            wiek = wiek - 1;
                        }
                    } else {   // peselmonth[0] == '3' - pazdz, list, gru
                        if (parseInt('1' + peselmonth[1]) == parseInt(nowmonth)) {
                            if (parseInt(pesel.substr(4, 2)) > parseInt(nowday)) {
                                wiek = wiek - 1;
                            }
                        } else if (parseInt('1' + peselmonth[1]) > parseInt(nowmonth)) {
                            wiek = wiek - 1;
                        }
                    }
                } else {   // roczniki 1900
                    wiek = parseInt(nowyear) - parseInt('19' + pesel.substr(0, 2));
                    if (parseInt(pesel.substr(2, 2)) == parseInt(nowmonth)) {
                        if (parseInt(pesel.substr(4, 2)) > parseInt(nowday)) {
                            wiek = wiek - 1;
                        }
                    } else if (parseInt(pesel.substr(2, 2)) > parseInt(nowmonth)) {
                        wiek = wiek - 1;
                    }

                }
                return wiek
            }
        }
    }

    componentWillMount() {
        this.getMiesiace();
        this.getBilety();
        BiletyMiesieczneService.getTrasy()
            .then(function (response) {
                let trasy = [];
                let res = response.data;
                for (let i = 0; i < res.length; i++) {
                    trasy.push({value: res[i].idTr, label: res[i].nazTr})
                }
                this.setState({trasy: trasy})
            }.bind(this)).catch(err => {
            console.log(err);
        });
    }

    getBilety() {
        BiletyMiesieczneService.getKarty(JSON.parse(sessionStorage.getItem('loggedIn')).idKl)
            .then(function (response) {
                this.setState({data: response.data, loading: false});
                if (this.props.zamowBilet === true) {
                    this.setState({showComponent: 0})
                } else {
                    this.setState({showComponent: 1})
                }
            }.bind(this)).catch(err => {
            console.log(err);
        });
    }

    getMiejscowosci(idTr) {
        BiletyMiesieczneService.getMiejscowosci(idTr)
            .then(function (response) {
                let miejscowosci = [];
                let res = response.data;
                for (let i = 0; i < res.length; i++) {
                    miejscowosci.push({value: res[i].idMi, label: res[i].nazMi})
                }
                this.setState({
                    miejscowosci: miejscowosci,
                    miejscowosciDo: miejscowosci,
                    miejscowoscOd: miejscowosci[0],
                    miejscowoscDo: miejscowosci[miejscowosci.length - 1]
                })
            }.bind(this)).then(() => {
            this.getZnizki(this.state.rok.value, this.state.miesiac.value, this.state.miejscowoscOd.value,
                this.state.miejscowoscDo.value, this.state.trasa.value, this.state.kierunek.value, this.state.okres.value)
        });

    }

    getZnizki(rok, miesiac, idMiOd, idMiDo, idTr, kierunek, okres) {
        BiletyMiesieczneService.getZnizkiMiesieczne((rok + '-' + miesiac + '-01'), idMiOd, idMiDo, idTr, kierunek, okres)
            .then(function (response) {
                let typy = [];
                let res = response.data;
                console.log(res)
                for (let i = 0; i < res.length; i++) {
                    if (res[i].cena !== null && res[i].cena !== 0) {
                        typy.push({
                            value: res[i].rodz,
                            label: res[i].nazZniz,
                            cena: res[i].cena,
                            ulga: res[i].ustawowa
                        })
                    }
                }
                this.setState({typy: typy})
            }.bind(this)).catch(err => {
            console.log(err);
        });
    }


    zlozWniosek() {
        if (this.state.typ !== '') {

            if (this.state.znizkaUstawowa) {


                let dataDok = JSON.parse(sessionStorage.getItem('loggedIn')).nrDokWaznyDo;
                if (dataDok !== null) {
                    if (moment(dataDok) >= moment()) {
                        if (LoginService.checkWiek(this.state.typ.value, JSON.parse(sessionStorage.getItem('loggedIn')).dataUrodzenia)) {
                            BiletyMiesieczneService.postKarta(JSON.parse(sessionStorage.getItem('loggedIn')).idKl, this.state.miejscowoscDo.value, this.state.miejscowoscOd.value,
                                this.state.trasa.value, this.state.kierunek.value, this.state.okres.value, this.state.typ.value, true)
                                .then((response) => {
                                    if (response.status === 200 || response.status === 201) {
                                        window.location.replace('/konto/bilety/miesieczne/success');
                                        this.getBilety()
                                    }
                                })
                        }
                    } else {
                        NotificationManager.error("", "Dokument nieważny ", 5000)
                    }
                } else {
                    NotificationManager.error("", "Brak danych dokumentu uprawniającego do zniżki ", 5000)
                }
            } else {
                BiletyMiesieczneService.postKarta(JSON.parse(sessionStorage.getItem('loggedIn')).idKl, this.state.miejscowoscDo.value, this.state.miejscowoscOd.value,
                    this.state.trasa.value, this.state.kierunek.value, this.state.okres.value, this.state.typ.value, true)
                    .then((response) => {
                        if (response.status === 200 || response.status === 201) {
                            window.location.replace('/konto/bilety/miesieczne/success');
                            this.getBilety()
                        }
                    })
            }

        } else {

            NotificationManager.error("", "Wybierz typ biletu ", 5000)


        }

    }

    renderZnizkiOption(option) {
        return <div><span className="cenaBiletuMies">{acc.formatMoney(option.cena, {
            symbol: 'zł',
            format: '%v %s'
        })}</span>{option.label}</div>
    }

    render() {
        return <Panel>
            <div className="container miesieczne">

                <h4 style={{textAlign: 'center', marginBottom: 20}}><b>Bilety miesięczne</b></h4>
                {!this.state.loading ? <div>
                    <div className="row" style={{marginBottom: 25}}>
                        <div className="col-sm-6 text-right buttonMiesieczneMobilka">
                            <Link to={'/konto/bilety/miesieczne'}><Button
                                onClick={() => this.setState({showComponent: 1, pokazSzczegolyKarty: false})}
                                bsStyle={this.state.data.length === 0 ? 'disabled' : 'warning'}
                                disabled={this.state.data.length === 0 ? true : false}
                                style={{color: 'white'}}>Moje
                                karty</Button></Link></div>
                        <div className="col-sm-6 text-left buttonMiesieczneMobilka">
                            <Link to={'/konto/bilety/miesieczne/zamow-bilet'}>
                                <Button onClick={() => this.setState({showComponent: 0})} bsStyle={'success'}>Zamów
                                    kartę</Button>
                            </Link>
                        </div>
                    </div>
                    <hr/>
                    {this.state.showComponent > 0 ?
                        <div>{!this.state.pokazSzczegolyKarty ?
                            <BiletyMiesiecznePokaz data={this.state.data}
                                                   pokazSzczegoly={() => this.setState({pokazSzczegolyKarty: true})}
                                                   item={(item) => this.setState({item})}/> :
                            <PokazSzczegolyKarty item={this.state.item}/>}</div>
                        : <div>
                            <b>Zamów kartę:</b>
                            <div className="row" style={{paddingTop: 10}}>
                                <div className="col-sm-3">
                                    Trasa:
                                    <Select
                                        onChange={this.onChangeTrasa}
                                        options={this.state.trasy}
                                        value={this.state.trasa}
                                        placeholder="Wybierz trasę"
                                        matchPos="start"
                                        clearable={false}
                                    />
                                </div>
                                <div className="col-sm-3">
                                    Miejscowość od:
                                    <Select
                                        onChange={this.onChangeMiejscowoscOd}
                                        options={this.state.miejscowosci}
                                        value={this.state.miejscowoscOd}
                                        placeholder="Wybierz miejscowość"
                                        matchPos="start"
                                        clearable={false}
                                        disabled={this.state.disabled}
                                    />
                                </div>
                                <div className="col-sm-3">
                                    Miejscowość do:
                                    <Select
                                        onChange={this.onChangeMiejscowoscDo}
                                        options={this.state.miejscowosciDo}
                                        value={this.state.miejscowoscDo}
                                        placeholder="Wybierz miejscowość"
                                        matchPos="start"
                                        clearable={false}
                                        disabled={this.state.disabled}
                                    />
                                </div>
                                <div className="col-sm-3">
                                    Kierunek:
                                    <Select
                                        value={this.state.kierunek}
                                        onChange={this.onChangeKierunek}
                                        clearable={false}
                                        options={[
                                            {value: 2, label: 'W obie strony'},
                                            {value: 1, label: 'W jedną stronę'},
                                        ]}
                                        matchPos="start"
                                        disabled={this.state.disabled}
                                    />
                                </div>
                            </div>
                            <div className="row" style={{paddingTop: 10}}>
                                <div className="col-sm-2">
                                    Rok:
                                    <Select
                                        onChange={this.onChangeRok}
                                        options={this.state.lata}
                                        value={this.state.rok}
                                        matchPos="start"
                                        g
                                        clearable={false}
                                        disabled={this.state.disabled}
                                    />
                                </div>
                                <div className="col-sm-2">
                                    Miesiąc:
                                    <Select
                                        onChange={this.onChangeMiesiac}
                                        options={this.state.miesiace}
                                        value={this.state.miesiac}
                                        placeholder="Wybierz miesiąc"
                                        matchPos="start"
                                        clearable={false}
                                        disabled={this.state.disabled}
                                    />
                                </div>
                                <div className="col-sm-3">
                                    Okres:
                                    <Select
                                        onChange={this.onChangeOkres}
                                        options={this.state.okresy}
                                        value={this.state.okres}
                                        matchPos="start"
                                        clearable={false}
                                        disabled={this.state.disabled}
                                    />
                                </div>
                                <div className="col-sm-5">
                                    Typ biletu:
                                    <Select
                                        onChange={this.onChangeTyp}
                                        options={this.state.typy}
                                        value={this.state.typ}
                                        valueRenderer={this.renderZnizkiOption}
                                        optionRenderer={this.renderZnizkiOption}
                                        placeholder="Wybierz bilet"
                                        matchPos="start"
                                        noResultsText={"Brak możliwości zakupu biletu"}
                                        clearable={false}
                                        disabled={this.state.disabled}
                                    />
                                </div>
                            </div>
                            <div className="row" style={{paddingTop: 20}}>
                                {/*<div className="col-sm-4" style={{fontSize: '0.875rem'}}>*/}
                                {/*    <input type="checkbox" checked={this.state.tylkoEkarta}*/}
                                {/*           onChange={() => this.setState({tylkoEkarta: !this.state.tylkoEkarta})}/> tylko*/}
                                {/*    eKarta<span style={{color: '#1e90ff'}}>*</span>*/}
                                {/*</div>*/}
                                <div className="col-sm-12 text-right">
                                    <Button bsStyle='success'
                                            disabled={this.state.disabled || this.state.typy.length === 0 || (this.state.znizkaUstawowa && JSON.parse(sessionStorage.getItem('loggedIn')).nrDokWaznyDo === null && JSON.parse(sessionStorage.getItem('loggedIn')).nrDok === null)}
                                            onClick={() => this.zlozWniosek()}>Wyślij zamówienie</Button>
                                </div>
                            </div>
                            <hr/>
                            <div className="row" style={{paddingTop: 5, fontSize: '0.75rem'}}>
                                <div className="col-sm-12 text-center">
                                        <span style={{color: '#1e90ff'}}>Zamawiając kartę przez stronę internetową karta fizyczna nie zostanie wydana. Dostęp do karty wirtualnej będzie możliwy przez aplikację mobilną. Karta
                                            zostanie aktywowana po weryfikacji poprawności zdjęcia pasażera.</span>
                                </div>
                            </div>
                            {this.state.znizkaUstawowa ?
                                <div>
                                    <div className="row">
                                        <div className="col-sm-12 text-center"
                                             style={{paddingTop: 5, fontSize: '0.75rem'}}>
                                            W przypadku wyboru karty ze zniżką ustawową kierowca jest uprawniony do
                                            weryfikacji dokumentu uprawniającego do zniżki.
                                        </div>
                                    </div>
                                    <hr/>
                                    <div style={{
                                        background: '#e4e7fd',
                                        padding: '15px',
                                        borderRadius: 10,
                                        border: '1px dashed #e5e5e5'
                                    }}>
                                        <div style={{fontSize: '0.875rem', paddingBottom: 10}}>
                                            <div className="inputLabel text-left" style={{paddingBottom: 10}}>Zniżka
                                                ustawowa:
                                            </div>
                                            Aby wybrać zniżkę ustawową należy potwierdzić uprawnienia odpowiednim
                                            dokumentem.
                                            <p><b>Uzupełnij dane dokumentu uprawniającego do zniżki.</b></p>
                                        </div>
                                        <ZnizkaUstawowa zakupKarty={true} typ={this.state.typ}/>
                                    </div>
                                </div>
                                : null}
                        </div>} </div> : <div style={{paddingTop: 10, textAlign: 'center', color: '#58b13d'}}>
                    <div className="loaderDim"><i className="fa fa-spinner fa-pulse fa-2x fa-fw"> </i></div>
                </div>}
            </div>
        </Panel>
    }

}



// WEBPACK FOOTER //
// ./src/components/konto/panel/panelComponents/mojeBiletyComponents/BiletyMiesieczne.js